var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupSheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4527",
    "data-name": "Grupo 4527",
    transform: "translate(-198 -324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Documento_Doble",
    "data-name": "Documento Doble",
    transform: "translate(222 348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Docs",
    transform: "translate(-8.256 -10.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7256",
    "data-name": "Trazado 7256",
    d: "M4.7,5.784V4.925h9.485v.859Zm0,3.027V7.952h9.485v.859Zm0,6.045V14h5.817v.854Zm0-3.022v-.858h9.485v.858ZM15.539,2.092a.974.974,0,0,1,.973.973V20.2a.974.974,0,0,1-.973.973H3.056a.974.974,0,0,1-.973-.973V19.117H.973A.974.974,0,0,1,0,18.144V0H1.115V18h.968V2.054H3.2v18H15.392V3.207l-11.2-.024,0-1.115,9.11.019V1.153l-11.2-.024,0-1.115,11.34.024a.974.974,0,0,1,.973.973V2.092Z",
    fill: "#006729"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSheets);
export default __webpack_public_path__ + "static/media/groupSheets.dbe661ab3da1765dcca23ff19aa2ae92.svg";
export { ForwardRef as ReactComponent };